<template>
  <div class="navigatorDiv">
    <span class="welcomeSpan">{{ $t("Welcome_Dear_Student") }}</span>
    <span class="chooseServicekSpan">{{ $t("Please_Choose_Service") }}</span>

    <router-link to="/regestration">
      <Button :label="regestrationBtnLabel" class="btnClass" />
    </router-link>

    <router-link to="/login">
      <Button :label="loginBtnLabel" class="btnClass" />
    </router-link>

    <!-- <router-link to="/login_embassy">
      <Button
        :label="adminOfficerBtnLabel"
        class="btnClass"
        style="background-color: var(--main-color2); border: none"
      />
    </router-link> -->
  </div>
</template>
<script>
export default {
  components: {},
  computed: {
    regestrationBtnLabel() {
      return this.$t("Register_New_Application");
    },
    loginBtnLabel() {
      return this.$t("Log_In");
    },
    adminOfficerBtnLabel() {
      return this.$t("Admin_officer_login");
    },
  },
};
</script>

<style scoped>
.header {
  padding: 5px 20px;
}

.navigatorDiv {
  display: flex;
  flex-direction: column;
  text-align: center;
  height: 100%;
  justify-content: center;
  padding: 30px !important;
}

.welcomeSpan {
  font-weight: bold;
  font-size: 1.3rem;
  margin: 5px;
}

.chooseServicekSpan {
  font-size: 1.3rem;
  margin: 10px;
}

.btnClass {
  width: 250px;
  margin: 5px auto;
  height: 45px;
  font-weight: bold;
  background-color: #028bff;
  color: #ffffff;
}

.infoLinkSpan {
  text-align: center;
  text-decoration: underline;
  letter-spacing: 0px;
  color: #028bff;
  cursor: pointer;
  text-transform: capitalize;
  margin: 5px 10px;
}

.footer {
  margin-bottom: 20px;
  text-align: center;
}
.logoImg {
  width: 15vh;
  height: 15vh;
  margin: 0 auto;
}
.logoContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  position: absolute;
  top: 15%;
  left: 50%;
  right: 0;
  padding-top: 10px;
  z-index: 1;
}
@media (max-width: 768px) {
  .logoContainer {
    top: 0;
    left: 0;
    right: 0;
  }
}
.systemName {
  font-size: 1rem;

  font-weight: bold;
  font-family: "Cairo";
  text-align: center;
}
</style>
